import { RowCellContent, Table, TableBody } from "@dash/table";
import { useTheme } from "@emotion/react";

import { Credit, Debit, History } from "@megaron/cash-rewards-contracts";

type Props = {
  history: History;
};

const tableHeadingList = [
  { heading: "Data" },
  { heading: "Typ" },
  { heading: "Opis" },
  { heading: "Kwota" },
];

export const AccountHistoryTable: React.FC<Props> = ({ history }) => {
  const theme = useTheme();

  const tableColumns = [
    {},
    ...tableHeadingList.map(
      ({ heading }) =>
        ({
          isSortable: false,
          label: heading,
        } as const),
    ),
  ];

  const sortedHistory = [...history].sort((a, b) => b.time.getTime() - a.time.getTime());

  const getEntryDescription = (entry: Credit | Debit): string => {
    if (entry.entryType === "credit") {
      return `Nagroda ${entry.rewardId.toUpperCase().split("-").join(" ")}`;
    } else {
      if (entry.blikCheckId) {
        return "Wypłata czeku BLIK";
      } else if (entry.santanderWithdrawalId) {
        return "Wypłata Santander";
      } else {
        return "Wypłata";
      }
    }
  };

  const getTableRowCellsContent = (entry: Credit | Debit): RowCellContent[] => {
    const isCredit = entry.entryType === "credit";
    const amount = entry.amount;
    const amountText = `${isCredit ? "+" : "-"}${amount.toFixed(2)} PLN`;

    return [
      {
        isLink: false,
        element: <div css={{ display: "flex", alignItems: "center", gap: 4 }} />,
      },
      {
        isLink: false,
        element: (
          <div>
            {entry.time.toLocaleDateString("pl-PL", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        ),
      },
      {
        isLink: false,
        element: (
          <div
            css={{
              textTransform: "capitalize",
            }}
          >
            {entry.entryType === "credit" ? "Wpływ" : "Wypływ"}
          </div>
        ),
      },
      {
        isLink: false,
        element: <div>{getEntryDescription(entry)}</div>,
      },
      {
        isLink: false,
        element: (
          <div
            css={{
              fontWeight: 600,
              color: isCredit ? theme.colors.success : theme.colors.danger,
            }}
          >
            {amountText}
          </div>
        ),
      },
    ];
  };

  return (
    <Table columns={tableColumns}>
      <TableBody
        rows={sortedHistory.map((entry) => ({
          uuid: entry.id,
          cellsContent: getTableRowCellsContent(entry),
        }))}
      />
    </Table>
  );
};
